/*! Shopify BNPL Widget — Calculation Engine | Version 3.0.0 */
(function (window) {
  "use strict";

  const ACCENTS = {
    payflex: "#003D79",
    moretyme: "#003D79",
    payjustnow: "#003D79",
    float: "#003D79",
    happypay: "#003D79",
    mobicred: "#003D79"
  };

  class BNPLEngine {
    constructor(options) {
      this.settings = Object.assign(
        { currency: "ZAR", locale: "en-ZA", payday: 27, mobicredInterest: 0.21 },
        options
      );
    }

    money(value) {
      return new Intl.NumberFormat(this.settings.locale, {
        style: "currency",
        currency: this.settings.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }

    round(value) {
      return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    }

    formatDate(date) {
      return date.toLocaleDateString(this.settings.locale, {
        day: "2-digit",
        month: "short"
      });
    }

    addDays(days) {
      const date = new Date();
      date.setDate(date.getDate() + days);
      return this.formatDate(date);
    }

    payday(monthOffset) {
      const today = new Date();
      const date = new Date(today.getFullYear(), today.getMonth() + monthOffset, 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
      date.setDate(Math.min(this.settings.payday, lastDay));
      return this.formatDate(date);
    }

    firstOfMonth(monthOffset) {
      const today = new Date();
      return this.formatDate(new Date(today.getFullYear(), today.getMonth() + monthOffset, 1));
    }

    plan(title, amount, dates) {
      return {
        title,
        amount,
        payments: dates.map((date) => ({ date, amount }))
      };
    }

    provider(id, title, badge, summaryLabel, summaryValue, plans) {
      return {
        id,
        title,
        badge,
        accent: ACCENTS[id],
        summary: { label: summaryLabel, value: summaryValue },
        plans
      };
    }

    calculate(price) {
      const amount = Number(price);
      if (!Number.isFinite(amount) || amount <= 0) return [];
      return [
        this.payflex(amount),
        this.payJustNow(amount),
        this.float(amount),
        this.happyPay(amount),
        this.moreTyme(amount),
        this.mobicred(amount)
      ];
    }

    payflex(price) {
      return this.provider("payflex", "Payflex", "No interest", "From", this.round(price / 4), [
        this.plan("Pay in 2", this.round(price / 2), ["Today", this.firstOfMonth(1)]),
        this.plan("Pay in 3", this.round(price / 3), ["Today", this.firstOfMonth(1), this.firstOfMonth(2)]),
        this.plan("Pay in 4", this.round(price / 4), ["Today", this.addDays(14), this.addDays(28), this.addDays(42)])
      ]);
    }

    moreTyme(price) {
      return this.provider("moretyme", "MoreTyme", "No interest", "3 ×", this.round(price / 3), [
        this.plan("3 payments", this.round(price / 3), ["Today", this.addDays(30), this.addDays(60)])
      ]);
    }

    payJustNow(price) {
      return this.provider("payjustnow", "PayJustNow", "No interest", "3 ×", this.round(price / 3), [
        this.plan("3 payments", this.round(price / 3), ["Today", this.payday(1), this.payday(2)])
      ]);
    }

    float(price) {
      const plans = [];
      for (let count = 2; count <= 6; count += 1) {
        const dates = ["Today"];
        for (let payment = 1; payment < count; payment += 1) {
          dates.push(this.payday(payment));
        }
        plans.push(this.plan("Pay in " + count, this.round(price / count), dates));
      }
      return this.provider("float", "Float", "Choose 2–6 payments", "From", this.round(price / 6), plans);
    }

    happyPay(price) {
      const installment = this.round(price / 2);
      return this.provider("happypay", "HappyPay", "R0 today", "Today", 0, [{
        title: "Payday plan",
        amount: installment,
        payments: [
          { date: "Today", amount: 0 },
          { date: this.payday(1), amount: installment },
          { date: this.payday(2), amount: installment }
        ]
      }]);
    }

    mobicred(price) {
      const months = 12;
      const rate = this.settings.mobicredInterest / 12;
      const monthly = this.round((price * rate) / (1 - Math.pow(1 + rate, -months)));
      return this.provider("mobicred", "Mobicred", "12-month finance", "Monthly", monthly, [{
        title: "Finance summary",
        amount: monthly,
        payments: [
          { date: "Monthly payment", amount: monthly },
          { date: "Total repayment", amount: this.round(monthly * months) },
          { date: "Interest rate", amount: Math.round(this.settings.mobicredInterest * 100) + "% p.a." }
        ]
      }]);
    }

    filterProviders(providers, enabled) {
      return Array.isArray(enabled)
        ? providers.filter((provider) => enabled.includes(provider.id))
        : providers;
    }
  }

  window.BNPLEngine = BNPLEngine;
})(window);
